import { useEffect, useState } from 'react';
import QRCode from 'qrcode';

/**
 * Encodes a person's id — the same value `qr-check-in-page.tsx` decodes
 * back with `jsqr` to resolve `GET /people/:id` and record an attendance
 * check-in. Reuses the exact `QRCode.toDataURL` pattern already proven in
 * `mfa-settings-page.tsx`'s TOTP enrollment QR.
 */
export function PersonQrCode({
  personId,
  size = 200,
  className,
}: {
  readonly personId: string;
  readonly size?: number;
  readonly className?: string;
}) {
  const [dataUrl, setDataUrl] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    setDataUrl(null);
    QRCode.toDataURL(personId, { width: size, margin: 1 })
      .then((url) => {
        if (!cancelled) setDataUrl(url);
      })
      .catch(() => {
        // Nothing sensible to show in place of a QR that failed to
        // render — the credential still shows the person's name.
      });
    return () => {
      cancelled = true;
    };
  }, [personId, size]);

  if (!dataUrl) return null;
  return <img src={dataUrl} alt="" width={size} height={size} className={className} />;
}
